import { string, shape, arrayOf } from 'prop-types';
import React from 'react';
import DebugBundleItem from 'components/DebugBundleItem';

/**
 * in dev mode, outputs a dump of the data passed to it. in prod mode, outputs
 * null component
 *
 */
function DebugBundle(props) {
  const { id, type, variant, data, items } = props;

  const isProd = process.env.NODE_ENV === 'production';

  return isProd ? null : (
    <div className="DebugBundle">
      <h5>DebugBundle ({`id: ${id}, type: ${type}, variant: ${variant}`})</h5>
      <h6>data</h6>
      <pre>{JSON.stringify(data, null, 2)}</pre>
      <h6>items</h6>
      <div>
        {items.map(itemProps => (
          <DebugBundleItem key={itemProps.id} {...itemProps.data} />
        ))}
      </div>
      <style jsx>{`
        .DebugBundle {
          background: #ccc;
          border: 1px solid #333;
          padding: 1em;
        }
      `}</style>
    </div>
  );
}

DebugBundle.propTypes = {
  id: string.isRequired,
  type: string.isRequired,
  variant: string,
  data: shape({}),
  items: arrayOf(shape({}))
};

DebugBundle.defaultProps = {
  variant: undefined,
  data: {},
  items: []
};

export default DebugBundle;
